export const dataForLoadingApis = ['All', 'TODO', 'NEW', 'CONSULTATION_BOOKED', 'CONSULTATION_ATTENDED', 'TREATMENT_STARTED', 'FAILED_TO_ATTEND_CONSULTATION', 'CLOSED'];

const normaliseTitles = (titles) => titles.map((title) => title.toLowerCase());

const sharedTitles = [
    'dashboard',
    'leads',
    'active leads',
    'lead management',
    'all patients',
    'dentally',
    'tasks',
    'reporting',
    'analytics',
    'financial tracker',
    'patient feedback',
    'campaign planner',
    'planner',
    'marketing calendar',
    'campaigns manager',
    'campaigns',
    'google reviews',
    'facebook',
    'facebook ads',
    'qr codes',
    'whatsapp',
    'more',
    'whatsapp beta',
    'sms',
    'emails',
    'notifications',

    'Call Logs',
    'instagram',
    'by practitioner',
    'by team',
    'user management',
    'meta reporting',
    'campaign reports',
    'ca pipeline (new)',
    'consent',
    'dentally insights',
    'reviews & feedback',
    'reviews & listing',
    'google posts',
    'form builder',
    'create practice',
    'feature flags',
    'engagement templates',
    'group dashboard',
    'manage groups',
    'overview',
    'website annotation',
    'more tools',
    'marketing tracker',
    'marketing campaigns',
    'triggers',
    'smart segments',
    'survey',
    'forms',
    'storage',
    'form delivery templates',
    'system task templates',
    'attended checklists',
];

export const allowedTitles = normaliseTitles(sharedTitles);

export const allowedTitlesVertical = normaliseTitles([...sharedTitles, 'messaging']);

export const allowedTitlesMini = normaliseTitles(sharedTitles);

export const emailTabs = ['Incoming', 'Outgoing', 'Drafts', 'Starred', 'Label'];
export const emailRoutes = ['Incoming', 'Outgoing', 'Drafts', 'Starred'];

export const sampleCsv = 'https://dentalsem-media-prod.ams3.digitaloceanspaces.com/dentalsem-crm-email-images/sample.csv';


export const tabs = [
    {
        title: 'Whatsapp',
        value: 'Whatsapp',
        icon: 'ic:round-whatsapp',
    },
    {
        title: 'Email',
        value: 'Incoming',
        icon: 'ion:mail',
    },
    {
        title: 'Chatbot',
        value: 'Chatbot',
        icon: 'fluent:bot-20-filled',
    },
    {
        title: 'Call Script',
        value: 'CallScript',
        icon: 'tabler:script',
    },
    {
        title: 'Call Logs',
        value: 'CallLogs',
        icon: 'mdi:phone-log',
    },
    {
        title: 'Attachments',
        value: 'Attachments',
        icon: 'fluent:attach-32-filled',
    },
    {
        title: 'Automations',
        value: 'Automations',
        icon: 'fad:automation-4p',
    },
];
